'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('../constants.js');

const SUPPORTED_SCRIPTS = [constants.UnicodeCharacterSet.Latin, constants.UnicodeCharacterSet.Han, constants.UnicodeCharacterSet.Hiragana, constants.UnicodeCharacterSet.Katakana, constants.UnicodeCharacterSet.Hangul, constants.UnicodeCharacterSet.Thai];
function identifyScripts(text) {
  return SUPPORTED_SCRIPTS.filter(supportedScript => new RegExp(`${supportedScript}`).test(text));
}

exports.identifyScripts = identifyScripts;
